import loadable from '@loadable/component';

export const InvalidLinkLoadable = loadable(() => import('./InvalidLink'), {
  resolveComponent: (module) => module.InvalidLink,
});
